import { render } from "./page3.vue?vue&type=template&id=0bdc6ed0&scoped=true"
import script from "./page3.vue?vue&type=script&lang=ts"
export * from "./page3.vue?vue&type=script&lang=ts"

import "./page3.vue?vue&type=style&index=0&id=0bdc6ed0&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-0bdc6ed0"

export default script